import React, { FC } from 'react'
import './BannerCard.css'
import { formatTitle } from 'shared/utils/formatFunction'
import clsx from 'clsx'

export interface BannerProps{
  description:string,
  title:string,
  image?:string,
  onClick: ()=>void,
}

export const BannerCard:FC <BannerProps> = ({title, image, onClick,description}) => {
  

  return (
        <div className={clsx("banner-card-cont card-shadow ")} onClick={onClick} >
          <div className="banner-card-bg d-flex flex-column p-2 ">
            <div className='flex-row d-flex '>
            <div className=" col-3 d-flex  align-items-center">
              <img src={image && image !== "" ? image : "/logo192.png"} alt="" className="banner-logo" />
            </div>
            <div className=" col-9 ps-2 py-1 flex-column d-flex justify-content-between ">
               <p className="m-0 p-0 banner-title w-100"><b>{formatTitle(title, 25)}</b></p>
               <p className='m-0 p-0 mt-2 banner-link text-end w-100 pe-1'> {"Show details"} </p>
            </div>
            </div>
            <div >
              <p className=' py-2 p-0 m-0 text-wrap banner-desc  text-break'>{formatTitle(description, 100)}</p>
            </div>
          </div>
        </div>
  )
}
